import React from 'react';
import Tooltip from './Tooltip';
import type { Placement } from '@react-types/overlays';

interface RocTitleProps {
	label: string;
	alignment?: Placement;
	offset?: number;
	isEnabled?: boolean;
	style?: any;
	children: React.ReactElement;
	wrap?: boolean;
}

function RocTitle(props: RocTitleProps) {
	return props.isEnabled ? (
		<Tooltip label={props.label} placement={props.alignment} offset={props.offset} wrap={props.wrap}>
			{props.children}
		</Tooltip>
	) : (
		<>{props.children}</>
	);
}

RocTitle.defaultProps = {
	isEnabled: true,
	alignment: 'right',
};

export default RocTitle;
